import { forwardRef, useEffect } from "react";

import { cn } from "../../utils/cn";
import { useDrawerContext } from "./context";

import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

export interface DrawerBodyProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const DrawerBody = forwardRef<HTMLDivElement, DrawerBodyProps>(
  ({ children, className, style, ...props }, ref) => {
    const { slots, classNames, bodyId, setBodyMounted, bodyStyle } = useDrawerContext();

    useEffect(() => {
      setBodyMounted(true);
      return () => setBodyMounted(false);
    }, [setBodyMounted]);

    // Merge bodyStyle from drawer props with any style passed to DrawerBody
    const mergedStyle: CSSProperties = { ...bodyStyle, ...style };

    return (
      <div
        ref={ref}
        id={bodyId}
        className={slots.body({ className: cn(classNames?.body, className) })}
        style={mergedStyle}
        data-slot="body"
        {...props}
      >
        {children}
      </div>
    );
  }
);
DrawerBody.displayName = "Drawer.Body";
